/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataUpdateCto } from '../../models/demo-account-data-update-cto';
import { DemoDataPublishResultCto } from '../../models/demo-data-publish-result-cto';

export interface PublishDemoAccountDataAsync$Plain$Params {
  demoDataType: ClassificationType;
      body?: DemoAccountDataUpdateCto
}

export function publishDemoAccountDataAsync$Plain(http: HttpClient, rootUrl: string, params: PublishDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
  const rb = new RequestBuilder(rootUrl, publishDemoAccountDataAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoDataPublishResultCto>;
    })
  );
}

publishDemoAccountDataAsync$Plain.PATH = '/demo-account-data/{demoDataType}';
